export enum EQuestionType {
  SINGLE_ANSWER = "multiple_choice_single_answer",
  MULTIPLE_ANSWER = "multiple_choice_multi_answer",
  BOOLEAN = "boolean",
  MATCHING = "matching_pairs",
  ORDERING = "ordering",
}

export default EQuestionType;
